<template>
  <div
    class="grid grid-cols-1"
    :class="[gridRows, gridCols, gap]"
  >
    <slot />
  </div>
</template>

<script setup>

import { computed } from 'vue';

const props = defineProps({
  rows: {
    type: [String, Number],
    default: null,
  },
  cols: {
    type: [String, Number],
    default: 1,
  },
  gap: {
    type: [String, Number],
    default: 4,
  },
});

const gridCols = computed(() => {
  const variants = {
    '1': 'md:grid-cols-1',
    '2': 'md:grid-cols-2',
    '3': 'md:grid-cols-3',
    '4': 'md:grid-cols-4',
    '5': 'md:grid-cols-5',
    '6': 'md:grid-cols-6',
    '7': 'md:grid-cols-7',
    '8': 'md:grid-cols-8',
    '9': 'md:grid-cols-9',
    '10': 'md:grid-cols-10',
    '11': 'md:grid-cols-11',
    '12': 'md:grid-cols-12',
  };

  return variants[props.cols] || null;
});

const gridRows = computed(() => {
  const variants = {
    '1': 'grid-rows-1',
    '2': 'grid-rows-2',
    '3': 'grid-rows-3',
    '4': 'grid-rows-4',
    '5': 'grid-rows-5',
    '6': 'grid-rows-6',
    '7': 'grid-rows-7',
    '8': 'grid-rows-8',
    '9': 'grid-rows-9',
    '10': 'grid-rows-10',
    '11': 'grid-rows-11',
    '12': 'grid-rows-12',
  };

  return variants[props.rows] || null;
});

const gap = computed(() => {
  const variants = {
    '1': 'gap-1',
    '2': 'gap-2',
    '3': 'gap-3',
    '4': 'gap-4',
    '5': 'gap-5',
    '6': 'gap-6',
    '7': 'gap-7',
    '8': 'gap-8',
    '9': 'gap-9',
    '10': 'gap-10',
    '11': 'gap-11',
    '12': 'gap-12',
  };

  return variants[props.gap] || null;
});

</script>
